export default "__VITE_ASSET__CMlAPMeg__"